module.exports = __webpack_public_path__ + "img/loader.b40650da.gif";